import axios from '@/axios'

export interface PriceCategory {
    id: number
    name: string
    description?: string
    subcategories: string[]
    is_active: boolean
    sort_order: number
    price_count: number
    created_at: string
    updated_at: string
}

export interface CreatePriceCategoryRequest {
    name: string
    description?: string
    subcategories?: string[]
    is_active?: boolean
    sort_order?: number
}

export interface UpdatePriceCategoryRequest {
    name?: string
    description?: string
    subcategories?: string[]
    is_active?: boolean
    sort_order?: number
}

class PriceCategoryService {
    async getAllCategories() {
        const response = await axios.get('/price-categories')
        return response
    }

    async getCategoryNames() {
        const response = await axios.get('/price-categories/names')
        return response
    }

    async getCategory(id: number) {
        const response = await axios.get(`/price-categories/${id}`)
        return response
    }

    async createCategory(data: CreatePriceCategoryRequest) {
        const response = await axios.post('/price-categories', data)
        return response
    }

    async updateCategory(id: number, data: UpdatePriceCategoryRequest) {
        const response = await axios.put(`/price-categories/${id}`, data)
        return response
    }

    async deleteCategory(id: number) {
        const response = await axios.delete(`/price-categories/${id}`)
        return response
    }
}

export default new PriceCategoryService()
